import { FC } from 'react'
import { observer } from 'mobx-react'
import { OutSideOverlay } from '@/components/atoms/OutSideOverlay'
import { AdInquiryFormGroup } from '@/components/molecules/AdInquiryFormGroup'
import { useStores } from '@/utils'
import { ColoredPageHeading } from '@/components/molecules/ColoredPageHeading'
import styles from './index.module.scss'

export const AdInqueryFormModal: FC = observer(() => {
  const { ui } = useStores()
  const toggleModal = () => {
    ui.toggleAdContactFormModalOpen()
  }

  return (
    <div className={styles.container} style={ui.isAdContactFormModalOpen ? {} : { display: 'none' }}>
      <OutSideOverlay onClick={toggleModal} isOpen={ui.isAdContactFormModalOpen} backGroundColor='gray' />
      <div className={styles.modal}>
        <div className={styles.card}>
          <div className={styles.heading}>
            <ColoredPageHeading heading='Contact the AQA Ads team'>
              <p className={styles.headingBody}>
                Thanks for your interest in AQA Ads. Please complete the form below, and a member of our sales team will
                reach out. We&apos;ll only use your email address to contact you per your advertising inquiry (read our{' '}
                <a href='https://aqa3.io/privacypolicy' target='_blank' rel='noreferrer'>
                  Privacy Policy
                </a>
                ).
              </p>
            </ColoredPageHeading>
          </div>
          <AdInquiryFormGroup />
        </div>
      </div>
    </div>
  )
})
